<template>
    <div>
        <!-- When not all items are selected-->
        <div v-if="!isAllSelected" class="well well-sm">
            You have selected <strong>{{ totalSelectedItems }}</strong> {{ verboseOperationName }} on the page.
            <button
                class="btn btn-outline btn-outline-info"
                type="button"
                @click="$emit('select-all-items')"
            >
                Select all <strong>{{ totalCount }}</strong> of your {{ verboseOperationName }}?
            </button>
        </div>

        <!-- When all items are selected-->
        <div v-else class="well well-sm">
            <template v-if="hasMorePages">
                <!-- When all items cannot be displayed in a single page-->
                All of your <strong>{{ totalSelectedItems }}</strong> {{ verboseOperationName }} have been selected.
                <button
                    class="btn btn-outline btn-outline-info"
                    type="button"
                    @click="$emit('clear-selections')"
                >
                    Clear selections
                </button>
            </template>
            <template v-else>
                <!-- When all items can be displayed in a single page-->
                You have selected <strong>{{ totalSelectedItems }}</strong> {{ verboseOperationName }}. There are no more {{ verboseOperationName }} to select.
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: "BulkActionHelperText",
    props: {
        totalSelectedItems: {
            type: Number,
            required: true
        },

        totalCount: {
            type: Number,
            required: true
        },

        pageLength: {
            type: Number,
            required: true
        },

        verboseOperationName: {
            type: String,
            required: true
        }
    },

    computed: {
        isAllSelected() {
            return this.totalSelectedItems == this.totalCount
        },

        hasMorePages() {
            return this.totalCount > this.pageLength
        }
    }
}
</script>

